import { render, staticRenderFns } from "./clazz-card-list-remake.vue?vue&type=template&id=ce31ffc8&scoped=true&"
import script from "./clazz-card-list-remake.vue?vue&type=script&lang=js&"
export * from "./clazz-card-list-remake.vue?vue&type=script&lang=js&"
import style0 from "./clazz-card-list-remake.vue?vue&type=style&index=0&id=ce31ffc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce31ffc8",
  null
  
)

export default component.exports